module.exports = __webpack_public_path__ + "static/media/Map.f767704c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/assets/Map.svg
// module id = 284
// module chunks = 0